import $ from 'jquery';
import apiFetch from '@wordpress/api-fetch';
import order from '@wc-stripe/order';
import {
    getSetting,
    getRestRoute,
    convertFormToFields,
    isNextActionRequired,
    registerPaymentMethod
} from '@wc-stripe/utils';
import AbstractCheckoutController from './AbstractCheckoutController';

class CheckoutController extends AbstractCheckoutController {

    wcCheckoutForm = null;

    constructor(props) {
        super(props);
        this.order = order;
        registerPaymentMethod(this.gateway);
    }

    initActions() {
        this.actions.addAction('updated_checkout', this.onUpdatedCheckout.bind(this));
        this.actions.addAction('payment_method_selected', this.onPaymentMethodSelected.bind(this));
        this.actions.addAction('payment_intent_requires_actions', this.onPaymentRequiresAction.bind(this));
        this.actions.addAction('setup_intent_requires_actions', this.onPaymentRequiresAction.bind(this));
        this.actions.addAction('checkout_order_review', this.onCheckoutOrderReview.bind(this));
        $(document.body).on('change', `[name="wc-${this.gateway.id}-payment-token"]`, this.onPaymentTokenChange.bind(this));
        $(document.body).on('change', `[name="wc-${this.gateway.id}-new-payment-method"]`, this.onSavePaymentMethodChange.bind(this));
        $(document.body).on('click', `li.payment_method_${this.gateway.id} .wc-stripe-saved-method, li.payment_method_${this.gateway.id} .woocommerce-SavedPaymentMethods-new`, this.onSavedTokenChanged.bind(this));
        $(document.body).on('click', `li.payment_method_${this.gateway.id} .wc-stripe-saved-method__see-more`, this.onSeeMoreClick.bind(this));
        if (this.context.isCheckout()) {
            $('form.checkout').on(`checkout_place_order_${this.gateway.id}`, this.onCheckoutPlaceOrder.bind(this));
            this.actions.addAction(`checkout_error_${this.gateway.id}`, this.onCheckoutError.bind(this));
        } else {
            $(document.body).on('click', '#place_order', this.onPlaceOrderClick.bind(this));
            // Use load event to ensure all scripts are loaded before triggering "wc-credit-card-form-init".
            $(window).on('load', () => {
                $(document.body).trigger('wc-credit-card-form-init');
            });
        }
    }

    isPaymentMethodAvailable() {
        if (this.context.isCheckout()) {
            const sections = this.gateway.getOption('paymentSections', []);
            if (Array.isArray(sections) && sections.length > 0 && !sections.includes('checkout')) {
                return false;
            }
        }
        return super.isPaymentMethodAvailable();
    }

    onUpdatedCheckout(e, data) {
        super.initialize();
        this.triggerPaymentMethodSelected();
        this.initSavedMethods();
    }

    initSavedMethods() {
        const $list = this.getSavedMethodsList();
        if (!$list.length) {
            return;
        }
        const $selected = this.getSelectedToken($list);
        if ($selected.length) {
            $list.prepend($selected);
        }
        this.hideSavedMethods($list);
    }

    onPaymentElementReady() {
        super.onPaymentElementReady();
        this.triggerPaymentMethodSelected();
        $(`li.payment_method_${this.gateway.id}`).show().addClass('active');

        // Hide payment_box if no saved payment tokens and no description (for express gateways only)
        if (this.gateway.supports('payment_sheet')) {
            if (!this.gateway.settings.hasPaymentTokens && !this.gateway.settings.description) {
                $(`.payment_method_${this.gateway.id} .payment_box`).addClass('hide-payment-box');
            } else {
                $(`.payment_method_${this.gateway.id} .payment_box`).removeClass('hide-payment-box');
            }
        }
    }

    onCheckoutPlaceOrder(e, wcCheckoutForm = null) {
        this.wcCheckoutForm = wcCheckoutForm;
        // check if a saved payment method is being used
        if (this.isSavedPaymentMethodSelected()) {
            return true;
        }

        // If the payment method or setup intent has been created, return early.
        if (this.gateway.hasPaymentMethodId() || this.gateway.hasSetupIntentId()) {
            return true;
        }

        // validate page if not supports form_validation
        if (!this.gateway.supports('form_validation')) {
            if (!this.isTermsAndConditionsValid()) {
                this.submitError({code: 'terms'});
                return false;
            }
        }


        this.processCheckout();

        return false;
    }

    onPlaceOrderClick(e) {
        if (!this.isPaymentGatewaySelected()) {
            return;
        }
        e.preventDefault();

        // If onCheckoutPlaceOrder returns true, submit the form
        // (saved payment method or payment method already created)
        if (this.onCheckoutPlaceOrder(null)) {
            this.submitForm();
        }
    }

    onCheckoutError(errorMessage) {
        if (this.gateway.supports('checkout_error')) {
            this.gateway.setPaymentMethodId('');
        }
    }

    onClick() {
        // validate terms and conditions
        if (!this.isTermsAndConditionsValid()) {
            this.submitError({code: 'terms'});
            throw new Error();
        }
        if (this.context.isCheckout() && this.gateway.supports('form_validation')) {
            if (!this.isCheckoutFormValid()) {
                this.validateCheckoutForm().then(response => {
                    if (!response.success) {
                        return this.submitError(response.messages);
                    }
                });
                throw new Error();
            }
        }
    }

    onPaymentTokenChange(e) {
        if (!this.isPaymentGatewaySelected()) {
            return;
        }
        if (this.isSavedPaymentMethodSelected()) {
            if (!this.gateway.supports('place_order_button')) {
                this.hidePaymentElement();
                this.displayPlaceOrderButton();
            }
            this.collapseSavedMethods();
        } else {
            if (!this.gateway.supports('place_order_button')) {
                this.displayPaymentElement();
                this.hidePlaceOrderButton();
            }
            this.collapseSavedMethods();
        }
    }

    onSavedTokenChanged(e) {
        const $li = $(e.currentTarget);
        const $list = $li.closest('.woocommerce-SavedPaymentMethods');
        $list.children('li').removeClass('selected');
        $li.addClass('selected');
        $li.find('input[type="radio"]').prop('checked', true).trigger('change');
    }

    onSeeMoreClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const $link = $(e.currentTarget);
        const $list = $link.closest('.woocommerce-SavedPaymentMethods');
        const isExpanded = $list.find('.wc-stripe-saved-method:hidden').length > 0;
        if (isExpanded) {
            this.showSavedMethods($list);
        } else {
            this.hideSavedMethods($list);
        }
    }

    collapseSavedMethods() {
        const $list = this.getSavedMethodsList();
        const $selected = this.getSelectedToken($list);
        if ($selected.length) {
            $list.prepend($selected);
        }
        this.hideSavedMethods($list);
        const $link = $list.find('.wc-stripe-see-more a');
        $link.text($link.data('showMore'));
    }

    hideSavedMethods($list) {
        $list.removeClass('wc-saved-payment-methods__expanded');
        $list.find('.wc-stripe-saved-method')
            .not(':first')
            .hide();
    }

    showSavedMethods($list) {
        $list.addClass('wc-saved-payment-methods__expanded');
        $list.find('.wc-stripe-saved-method').show();
    }

    getSelectedToken($list) {
        return $list.find('input[type="radio"]:checked').closest('.wc-stripe-saved-method');
    }

    getSavedMethodsList() {
        return $(`li.payment_method_${this.gateway.id} .woocommerce-SavedPaymentMethods`);
    }

    async onPaymentRequiresAction(data) {
        if (!this.isPaymentGatewaySelected()) {
            return;
        }
        if (this.gateway.supports('payment_sheet') && !this.gateway.isPaymentSheetOpen()) {
            return;
        }
        try {
            const result = await this.handleIntentConfirmation(data, {
                skipElements: this.isSavedPaymentMethodSelected()
            });

            // Redirect to complete the order
            window.location.href = this.getPostAuthenticationRedirectUrl(data, result);
        } catch (error) {
            this.gateway.clearElementSubmitted();
            this.gateway.setPaymentMethodId('');
            this.gateway.setSetupIntentId('');
            this.getForm().removeClass('processing').unblock?.();
            return this.submitError(error);
        }
    }

    onCheckoutOrderReview(props) {
        if (!this.isPaymentGatewaySelected()) {
            return;
        }
        this.gateway.setPaymentMethodId(props.payment_method_id);
        // Select "new" payment token (not saved payment method)
        $(`[name="wc-${this.gateway.id}-payment-token"][value="new"]`).trigger('click');
    }

    onSavePaymentMethodChange(e) {
        const $el = $(e.currentTarget);
        this.gateway.setSavePaymentMethod($el.is(':checked'));
        this.gateway.updateElements();
    }

    async processCheckout() {
        try {
            await this.gateway.validatePaymentElement();
            if (this.actions.applyFilters(
                'wc_stripe_should_create_payment_method',
                this.gateway.shouldCreatePaymentMethod())
            ) {
                await this.createPaymentMethod();
            } else {
                await this.submit(null);
            }
        } catch (error) {
            this.submitError(error);
        }
    }

    async submit(checkoutData = null) {
        if (checkoutData) {
            this.populateCheckoutFields(
                checkoutData,
                {skipBilling: true}
            );
        }

        if (this.gateway.supports('payment_sheet')) {
            this.hidePaymentElement();
            this.displayPlaceOrderButton();
        }

        if (this.context.isOrderPay()) {
            if (!this.gateway.isSetupMode()) {
                return await this.processOrderPay();
            }
            return await this.createSetupIntent();
        }

        this.submitForm();
    }

    /**
     * Process the payment when the order is paid for on the order pay page.
     * @returns {Promise<void>}
     */
    async processOrderPay() {
        try {
            this.showProcessing();
            const response = await this.order.processPayment(
                this.gateway.id,
                convertFormToFields(this.getForm())
            );
            // handle any 3DS authentication
            if (!response.complete) {
                const data = isNextActionRequired(response.redirect);
                if (data) {
                    await this.handleIntentConfirmation(data);
                    this.submitForm();
                }
            } else {
                this.submitForm();
            }
        } catch (error) {
            this.gateway.setPaymentMethodId('');
            return this.submitError(error);
        } finally {
            this.hideProcessing();
        }
    }

    populateCheckoutFields(data, options = {}) {
        super.populateCheckoutFields(data, options);
        if (data.paymentMethodId) {
            const key = `${this.gateway.id}_payment_method_id`;
            if (!$(`[name="${key}"]`).length) {
                $('form.checkout').append(`<input type="hidden" name="${key}" value="${data.paymentMethodId}" />`);
            }
            this.gateway.setPaymentMethodId(data.paymentMethodId);
        }
    }

    submitForm() {
        if (this.actions.applyFilters('checkout_submit_form', true)) {
            this.getForm().trigger('submit');
        }
    }

    isCheckoutFormValid() {
        const errors = [];
        // Query fields that WooCommerce currently marks as required (respects country-based changes)
        $('.validate-required:visible').each((index, wrapper) => {
            const $wrapper = $(wrapper);
            const $input = $wrapper.find('input, select, textarea').first();

            if ($input.length && $input.is(':visible')) {
                const fieldName = $input.attr('name');
                if ($input.attr('type') === 'checkbox') {
                    if (!$input.is(':checked')) {
                        errors.push(fieldName);
                    }
                } else if ($input.val() === '' || $input.val() === null) {
                    errors.push(fieldName);
                }
            }
        });
        return errors.length === 0;
    }

    isTermsAndConditionsValid() {
        if ($('[name="terms"]').filter(':visible').length) {
            return $('[name="terms"]').is(':checked');
        }
        return true;
    }

    async validateCheckoutForm() {
        try {
            this.disablePaymentElement();
            this.showProcessing();
            return await apiFetch({
                method: 'POST',
                url: getRestRoute('checkout/form-validation'),
                data: convertFormToFields($('form.checkout'))
            });
        } catch (error) {
            return {success: true};
        } finally {
            this.enablePaymentElement();
            this.hideProcessing();
        }
    }

    getProcessingSelector() {
        if (this.context.isOrderPay()) {
            return 'form#order_review';
        }
        return 'form.checkout';
    }

    needsShipping() {
        //Only express checkout checks for shipping since the customer will have already filled out
        return false;
    }

    getCurrency() {
        if (this.context.isOrderPay()) {
            return this.order.getCurrency();
        }
        return this.cart.getCurrency();
    }

    getTotalCents() {
        if (this.context.isOrderPay()) {
            return this.order.getTotalCents();
        }
        return this.cart.getTotalCents();
    }

    getLineItems() {
        if (this.context.isOrderPay()) {
            return this.order.getLineItems();
        }
        return super.getLineItems();
    }
}

export default CheckoutController;